var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.47 0.5 0 4.97 0 10.5C0 16.03 4.47 20.5 10 20.5C15.53 20.5 20 16.03 20 10.5C20 4.97 15.53 0.5 10 0.5ZM14.3 14.8C13.91 15.19 13.28 15.19 12.89 14.8L10 11.91L7.11 14.8C6.72 15.19 6.09 15.19 5.7 14.8C5.31 14.41 5.31 13.78 5.7 13.39L8.59 10.5L5.7 7.61C5.31 7.22 5.31 6.59 5.7 6.2C6.09 5.81 6.72 5.81 7.11 6.2L10 9.09L12.89 6.2C13.28 5.81 13.91 5.81 14.3 6.2C14.69 6.59 14.69 7.22 14.3 7.61L11.41 10.5L14.3 13.39C14.68 13.77 14.68 14.41 14.3 14.8Z",
    fill: "#CA3629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.871c79dfcdec07849f4540a6555b7abb.svg";
export { ForwardRef as ReactComponent };